import TreeView from './TreeView.vue';

export default [
  TreeView,
];
